// # /packages/color-picker/index.js
// 导入组件，组件必须声明 name
import CloudDisk from './src/cloud-disk.vue'

// 默认导出组件
export default { CloudDisk }
